export default "__VITE_ASSET__Ck6G$3n1__"